import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAI } from "../hooks/useAI";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { COLORS, SERIF, SANS, formStyles, pageStyles } from "../components/dispute/theme";

// Landing page after Stripe Connect onboarding (account link return_url).
export default function ConnectReturn() {
  const navigate = useNavigate();
  const { connectStatus } = useAI();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    connectStatus().then(setStatus);
  }, [connectStatus]);

  const ready = status?.payoutsEnabled;

  return (
    <div style={pageStyles.root}>
      <SiteHeader />
      <div style={pageStyles.shell}>
        <div style={pageStyles.card}>
          <h1 style={styles.title}>Payout setup</h1>
          {status == null ? (
            <p style={styles.body}>Checking your payout account…</p>
          ) : ready ? (
            <p style={styles.body}>
              ✅ Your payout account is ready. Go back to your dispute and claim your payout.
            </p>
          ) : (
            <p style={styles.body}>
              Your payout account isn't fully set up yet. You can return to the dispute and start the
              claim again to finish onboarding.
            </p>
          )}
          <button
            type="button"
            style={{ ...formStyles.primaryButton, marginTop: 16 }}
            onClick={() => navigate("/all-disputes")}
          >
            Go to my disputes
          </button>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}

const styles = {
  title: { fontFamily: SERIF, fontSize: 28, fontWeight: 600, margin: "0 0 12px 0", color: COLORS.ink },
  body: { fontSize: 14, color: COLORS.inkSoft, lineHeight: 1.6, fontFamily: SANS },
};
